const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");
const StatsIcon = require("../core/view/StatsIcon");
const PieGraph = require("../core/view/PieGraph");
const ColorUtil = require("../core/util/ColorUtil");
const OpsLab = require("../lab/vault/OpsLab");

const styles = require("./styles/HistoryIcon.css");

module.exports = createReactClass({
	displayName: "HistoryIcon",

	propTypes: {
		type: PT.oneOf(
			["stars", "intervened", "partial", "empty", "quit"].concat(
				OpsLab.getCelestialHashes()
			)
		),
		finishStatus: PT.string,
		iconClass: PT.string,
		celestialEarned: PT.bool,
		numStars: PT.number,
		percentComplete: PT.number,
		hasTrophy: PT.bool,
		trophyAvailable: PT.bool,
		hideStarIcon: PT.bool,
		grayBackground: PT.bool,
		backgroundColor: PT.string,
		backgroundIconType: PT.oneOf(["bonus"]),
		onClick: PT.func,
	},

	render: function() {
		const {
			iconClass,
			percentComplete,
			numStars,
			finishStatus,
			celestialEarned,
			grayBackground,
			hasTrophy,
			trophyAvailable,
			hideStarIcon,
			backgroundColor,
			onClick,
			backgroundIconType,
		} = this.props;
		const colors = ColorUtil.getCurrentScheme();
		let type = this.props.type;
		if (!type) {
			if (finishStatus === "intervened" || finishStatus === "quit") {
				type = "intervened";
			} else if (
				finishStatus === "completed" ||
				numStars ||
				percentComplete === 1
			) {
				type = "stars";
			} else if (percentComplete) {
				type = "partial";
			} else {
				type = "empty";
			}
		}

		const blueStarColors = ColorUtil.getBlueStarColors(4);
		const purpleCelestialColors = ColorUtil.getPurpleCelestialColors(4);

		let icon;
		const iconStyle = {};
		const allCelestials = OpsLab.getCelestialHashes();

		if (type === "stars") {
			iconStyle.backgroundColor = blueStarColors[3 - numStars];
			let subIcon = null;
			let starClass = styles.stars;
			const trophyUnlocked = numStars >= 1;
			if (!hideStarIcon) {
				subIcon = (
					<StatsIcon className={styles.starsImg} type="star" style="office" />
				);
			} else if (hasTrophy || (trophyAvailable && trophyUnlocked)) {
				const trophyColor = hasTrophy
					? null
					: ColorUtil.getCurrentScheme().white;
				subIcon = (
					<StatsIcon
						className={styles.trophyImg}
						type="trophy"
						color={trophyColor}
						style="office"
					/>
				);
			} else {
				starClass = styles.starsOnly;
			}
			icon = (
				<div className={starClass}>
					{numStars}
					{subIcon}
				</div>
			);
		} else if (_.includes(allCelestials, type)) {
			const cel = OpsLab.getCelestialFromHash(type);
			const isPartial = percentComplete > 0 && percentComplete < 1;
			let partial;
			let iconColor;
			const purple = purpleCelestialColors[allCelestials.length - cel.id];
			if (isPartial) {
				const data = [
					{color: purple, percent: percentComplete},
					{color: colors.lightGrayFill, percent: 1 - percentComplete},
				];
				partial = (
					<PieGraph
						className={styles.partial}
						data={data}
						backgroundColor={
							grayBackground ? colors.lightGrayFill : backgroundColor
						}
					/>
				);
				iconColor = colors.lighterGrayFill;
			} else if (celestialEarned) {
				iconStyle.backgroundColor = purple;
			} else {
				iconStyle.backgroundColor = colors.lightGrayFill;
				iconColor = colors.lighterGrayFill;
			}
			icon = (
				<div className={styles.celestial}>
					{partial}
					<StatsIcon
						className={styles.celImg}
						type={type}
						color={iconColor}
						style="office"
					/>
				</div>
			);
		} else if (type === "intervened") {
			iconStyle.backgroundColor = ColorUtil.getCurrentScheme().lightGrayFill;
			icon = (
				<StatsIcon
					className={styles.intervened}
					type="intervened"
					style="office"
				/>
			);
		} else if (type === "partial") {
			const data = [
				{color: blueStarColors[0], percent: percentComplete},
				{color: colors.lightGrayFill, percent: 1 - percentComplete},
			];
			const partial = (
				<PieGraph
					className={styles.partial}
					data={data}
					backgroundColor={
						grayBackground ? colors.lightGrayFill : backgroundColor
					}
				/>
			);
			if (backgroundIconType === "bonus") {
				icon = (
					<React.Fragment>
						{partial}
						<div className={styles.iconContainer}>
							<StatsIcon
								className={styles.bonusImg}
								type="bonus"
								color={colors.transparentWhite}
								style="office"
							/>
						</div>
					</React.Fragment>
				);
			} else {
				icon = partial;
			}
		} else if (type === "empty") {
			icon = <div className={styles.empty} />;
		}

		let mainClass = type === "stars" ? styles.mainStars : styles.main;
		if (iconClass) {
			mainClass += " " + iconClass;
		}
		if (onClick) {
			mainClass += " " + styles.clickable;
		}

		let bgIcon = null;
		if (backgroundIconType) {
			iconStyle.position = "relative";
			const backgroundIconClass =
				backgroundIconType === "bonus" ? styles.bonusImg : "";
			const backgroundIconColor =
				backgroundIconType === "bonus" ? colors.transparentWhite : "";
			bgIcon =
				type === "partial" ? null : (
					<div className={styles.iconContainer}>
						<StatsIcon
							className={backgroundIconClass}
							type={backgroundIconType}
							color={backgroundIconColor}
							style="office"
						/>
					</div>
				);
		}

		return (
			<div className={mainClass} style={iconStyle} onClick={onClick}>
				{bgIcon}
				{icon}
			</div>
		);
	},
});
